var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle"},[_vm._t("default",null,{"val":_vm.val,"setVal":_vm.setVal,"toggleVal":_vm.toggleVal})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }